import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../assets/js/LanguageContext';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [message, setMessage] = useState(t('oauth_processing'));

  useEffect(() => {
    const completeOAuthLogin = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const refreshToken = params.get('refreshToken');
      const error = params.get('error');

      if (error) {
        console.error('[OAuthCallback] backend error:', error);
        setMessage(t('oauth_error'));
        setTimeout(() => navigate('/login'), 2500);
        return;
      }

      if (!token) {
        setMessage(t('oauth_error'));
        setTimeout(() => navigate('/login'), 2500);
        return;
      }

      localStorage.setItem('token', token);
      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
      }

      // Mis diagnósticos recoge las preguntas generadas en la landing antes de entrar
      window.location.replace('/dashboard');
    };

    completeOAuthLogin();
    // Solo al volver del proveedor
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div className="common-container">
      <div className="login-container login-container--verification">
        <div className="login-form login-form--verification">
          <h2>{message}</h2>
        </div>
      </div>
    </div>
  );
};

export default OAuthCallback;
